// @flow

import React from 'react';

import {
  Card,
  Columns,
  Section,
  Text,
  TextLink,
  Hidden
} from 'seek-style-guide/react';

import NavLink from 'src/components/NavLink/NavLink';
import SaveJobButton from './SaveJobButton/SaveJobButton';
import SendJobButton from './SendJobButton/SendJobButton';

import styles from './JobActionsCard.less';

type Props = {
  job: ChaliceJobDetail,
  isApplied: boolean,
  isSaved: boolean
};

const JobActionsCard = ({ job, isApplied, isSaved }: Props) => (
  <Card>
    <Section>
      {isApplied ? (
        <SendJobButton job={job} />
      ) : (
        <Columns tight>
          <Hidden mobile>
            <SaveJobButton job={job} className={styles.saveJobButton} />
          </Hidden>
          <SendJobButton job={job} />
        </Columns>
      )}
      {isSaved && (
        <Text
          className={styles.savedJobsInfo}
          secondary
          data-automation="saved-job-info"
        >
          Go to your&nbsp;
          <NavLink
            component={TextLink}
            rel="nofollow"
            location={{ pathname: 'my-activity/saved-jobs' }}
          >
            Saved jobs
          </NavLink>
          &nbsp;to add notes
        </Text>
      )}
    </Section>
  </Card>
);

export default JobActionsCard;
